import { TranslationActions, TranslationActionTypes } from './translation.actions';

export interface TranslationData {
    timestamp?: string;
    [key: string]: any;
}

export interface TranslationState {
    translations: { [lang: string]: TranslationData };
}

export const translationInitialState: TranslationState = {
    translations: {}
};

export function translationReducer(
    state = translationInitialState,
    action: TranslationActions
): TranslationState {
    switch (action.type) {
        case TranslationActionTypes.LOAD_TRANSLATION:
            return {
                ...state
            };

        case TranslationActionTypes.LOAD_TRANSLATION_SUCCESS:
            return {
                ...state,
                translations: {
                    ...state.translations,
                    [action.payload.lang]: action.payload.translations
                }
            };

        case TranslationActionTypes.LOAD_TRANSLATION_ERROR:
            return {
                ...state
            };

        case TranslationActionTypes.CLEAR_TRANSLATIONS:
            return translationInitialState;

        default:
            return state;
    }
}

